export interface IHighlightPart {
  text: string
  hit: boolean
}

/**
 * Разбивает текст на фрагменты для безопасной подсветки поиска.
 * Каждое слово запроса ищется отдельно: «Врач аку» подсветит и «Врач», и «аку» в «Врач-акушер».
 * Совпадения помечаются hit=true; HTML из исходной строки не интерпретируется.
 */
export function highlightSearchParts(
  text: string | null | undefined,
  searchTerm: string | null | undefined,
): IHighlightPart[] {
  const source = text ?? ''
  const query = (searchTerm ?? '').trim()

  if (!source) {
    return []
  }

  if (!query) {
    return [{ text: source, hit: false }]
  }

  const words = query
    .split(/\s+/)
    .filter(Boolean)
    .sort((a, b) => b.length - a.length)
    .map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  const tokens = source.split(new RegExp(`(${words.join('|')})`, 'gi'))
  const parts: IHighlightPart[] = []

  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i]
    if (!token) continue
    parts.push({ text: token, hit: i % 2 === 1 })
  }

  return parts.length ? parts : [{ text: source, hit: false }]
}
